/*
 * Convert Experiments conversion goals for the product card quick adds.
 *
 * One delegated listener covers both the server-rendered cards (card-product.liquid)
 * and the ones Searchspring renders client side, since those get re-rendered and a
 * per-button listener would be lost.
 */
(function () {
  if (window.__convertQuickAddGoalsInit) return;
  window.__convertQuickAddGoalsInit = true;

  var GOALS = {
    // PLP - Quick Add Icon (bottom-left of the card media)
    mediaIcon: '1004126881',
    // MOBILE QUICK ADD - paste the goal id from Convert here once the goal is saved
    mobileQuickAdd: ''
  };

  // Matches the breakpoint where the quick add sits permanently under each card.
  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function trigger(goalId) {
    if (!goalId) return;
    window._conv_q = window._conv_q || [];
    window._conv_q.push(['triggerConversion', goalId]);
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('.product-card-wrapper')) return;

      var icon = target.closest('.card-media-atc');
      if (icon) {
        if (!icon.classList.contains('loading')) trigger(GOALS.mediaIcon);
        return;
      }

      // isTrusted skips the synthetic click the media icon forwards to Searchspring's
      // quick add, so an icon click is not counted twice.
      var quickAdd = target.closest('.quick-add:not(.image-overlay-atc-wrapper) .quick-add__submit');
      if (quickAdd && event.isTrusted && mobileQuery.matches && !quickAdd.classList.contains('loading')) {
        trigger(GOALS.mobileQuickAdd);
      }
    },
    true
  );
})();
